module.exports = __webpack_public_path__ + "static/media/chevron-left.b298313b.svg";